export class Guard {
  static against(predicate: (() => boolean) | boolean, msg = 'Unknown error') {
    const error =
      typeof predicate === 'function' ? (<() => boolean>predicate)() : predicate === true;
    if (error) throw new Error(msg);
  }
}
